import { Trans } from 'react-i18next';

import { StudentOnboardingPageTranslations } from '../../../../i18n';
import { ColoredText, TitleText } from '../../../../styles';

interface TranslatedTitleProps {
  i18nKey: keyof typeof StudentOnboardingPageTranslations;
}

export const TranslatedTitle = ({ i18nKey }: TranslatedTitleProps) => {
  return (
    <TitleText>
      <Trans
        i18nKey={`StudentOnboardingPageTranslations:${i18nKey}`}
        components={{
          span: <ColoredText />
        }}
      />
    </TitleText>
  );
};
